import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';

import ElinxCollectContainer from './ElinxCollectContainer';
import ElinxConnectContainer from './ElinxConnectContainer';
import ElinxPayContainer from './ElinxPayContainer';
import ElinxFlexContainer from './ElinxFlexContainer';
import ElinxHistory from '../ElinxHistory/ElinxHistory';
import ElinxDetailsPage from '../ElinxHistory/Details/ElinxDetailsPage';
import ElinxConfirmationPage from '../ElinxHistory/Confirmation/ElinxConfirmationPage';
import ProtectedRoute from '../../../utils/ProtectedRoute';

const Routes: React.FC = () => {
  const featureFlags = useModuleFeatureFlag('eLinx');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && !!featureFlags.CreateElinxCollect}
        showPermission
        exact
        path="/elinx/collect"
        component={ElinxCollectContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && !!featureFlags.CreateElinxPay}
        showPermission
        exact
        path="/elinx/pay"
        component={ElinxPayContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && !!featureFlags.CreateElinxConnect}
        showPermission
        exact
        path="/elinx/connect"
        component={ElinxConnectContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && !!featureFlags.CreateElinxFlex}
        showPermission
        exact
        path="/elinx/flex"
        component={ElinxFlexContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/elinx-history"
        component={ElinxHistory}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/elinx-history/details/:ELinxId"
        component={ElinxDetailsPage}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/elinx-history/:type/confirmation/:eLinxId/:notificationMethod/:eFlexOption"
        component={ElinxConfirmationPage}
      />
    </Switch>
  );
};

export default Routes;
